<template>
  <div class="life4">
    <div>
      本區屬阿里山山脈尾稜，為海拔約80~350公尺左右的丘陵地，地勢東陡西緩，由於地質特殊加上河流侵蝕沖刷，形成的自然景觀也成為本區最具特色的景觀資源，地勢較低的崎頂等地，屬黃砂土地質，景觀則多為青蔥山林，而海拔最高的龍船窩(351.6五公尺之「船帆」處)則可俯瞰大片青灰岩之草木不生的月世界，相當特殊。
    </div>
    <div>&nbsp;</div>
    <div id="street">․崎頂老街</div>
    <div>&nbsp;</div>
    <div>
      <img src="~@/assets/images/life-page4-img-1.jpg" />
    </div>
    <div>&nbsp;</div>
    <div>
      龍崎區崎頂里舊街，主要是舊182縣道的沿線街面，崎頂里於日治時代為「崎頂第一保」，不但是龍崎人口密度、村民數最多的庄村，這條道路也是當時全鄉政經、文史及農業中心的所在地，加上崎頂因開
      發速度較快，故在日治時代，幾乎已經發展成現今規模，且樣貌一直保留至今。
    </div>
    <div>&nbsp;</div>
    <div id="story">․竹炭故事館</div>
    <div>&nbsp;</div>
    <div>
      <img src="~@/assets/images/life-page4-img-2.jpg" />
    </div>
    <div>&nbsp;</div>
    <div>
      竹炭故事館的建築物本身為日治時期所遺留下來的歷史老建物，原是龍崎鄉公所，因公所閒置多年，經農會租用並規劃成為竹炭故事館，擺放竹炭展示物品，竹炭功能簡介，設立竹子的製作過程做成產品給遊客參觀，除了展示功能，也開發竹炭產品和當地農產品販售區。
    </div>
    <div>&nbsp;</div>
    <div id="park">․虎形山公園</div>
    <div>&nbsp;</div>
    <div>
      <img src="~@/assets/images/life-page4-img-3.jpg" />
    </div>
    <div>&nbsp;</div>
    <div>
      虎形山山形如猛虎雄踞，故有「虎形山」之名，海拔只有113公尺，是新化丘陵與嘉南平原銜接的最高峰！有山有水，且未受人為破壞，自然生態環境極佳，常可見野生動物。特色有望龍吊橋、森林浴、.露營烤肉遊戲區、環山步道、香草植物區、天然竹林與野生動物，夜間，還有四處飛舞，一閃一閃的螢火蟲。&nbsp;
    </div>
    <div>&nbsp;</div>
    <div id="farm">․牛埔農塘</div>
    <div>&nbsp;</div>
    <div>
      <img src="~@/assets/images/life-page4-img-4.jpg" />
    </div>
    <div>&nbsp;</div>
    <div>
      牛埔地區以光禿一片的月世界地形最為特別，牛埔湖的四周都是這樣的地形，四周不同於一般充滿綠意盎然的山景，也迥異於草山月世界一片灰白，這裡毫無枝葉遮掩，形體外貌一一展露眼前，山勢陡峭峻偉，顯得莊嚴，氣勢震人，十分壯觀。山的周圍些許綠意，像似裙襬滾邊一樣，有剛強中帶著些許溫柔的獨特風貌，山矗立在湖的四周，就像湖的守護天使，守護這片湖水。牛埔湖經農林廳規劃建造成人工水壩，作為牛埔村灌溉蓄水之用，並具調節河川流量之功能，湖畔設有涼亭，可以居高俯瞰此湖全貌。
    </div>
    <div>&nbsp;</div>
    <div>&nbsp;</div>
    <div>
      <img src="~@/assets/images/life-page1-img-1.jpg" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Life4',
  data() {
    return {
      page: this.$route.query.page,
    };
  },
  watch: {
    $route() {
      this.page = this.$route.query.page;
    },
  },
  mounted() {
    const name = this.$route.query.name;
    if (typeof window === undefined) {
      return;
    }
    let offsetTop = document.querySelector(`#${name}`).offsetTop || 0;
    if (offsetTop > 0) {
      const headerHeight = window.innerWidth < 768 ? 90 : 180;
      offsetTop -= headerHeight;
    }
    window.scrollTo({ behavior: 'auto', top: offsetTop });
  },
};
</script>

<style scoped>
.life4 img {
  width: 100%;
}
</style>
